import { blockAlign2FlexAlign } from '../../helper/blockitStyleHelpers.mjs';
import { getTextStyleV2, px2rem, BaseButton, ThemeColorScaleTypes } from '@moim/common';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

var commonStyle = css(["", " ", ";", ";", ";", ";text-align:center;"], function (props) {
  var _a, _b;
  return ((_a = props.customStyle) === null || _a === void 0 ? void 0 : _a.text) && getTextStyleV2((_b = props.customStyle) === null || _b === void 0 ? void 0 : _b.text);
}, function (props) {
  var _a, _b, _c;
  return ((_b = (_a = props.customStyle) === null || _a === void 0 ? void 0 : _a.padding) === null || _b === void 0 ? void 0 : _b.top) !== undefined ? css(["padding-top:", ";"], px2rem((_c = props.customStyle) === null || _c === void 0 ? void 0 : _c.padding.top)) : undefined;
}, function (props) {
  var _a, _b, _c;
  return ((_b = (_a = props.customStyle) === null || _a === void 0 ? void 0 : _a.padding) === null || _b === void 0 ? void 0 : _b.left) !== undefined ? css(["padding-left:", ";"], px2rem((_c = props.customStyle) === null || _c === void 0 ? void 0 : _c.padding.left)) : undefined;
}, function (props) {
  var _a, _b, _c;
  return ((_b = (_a = props.customStyle) === null || _a === void 0 ? void 0 : _a.padding) === null || _b === void 0 ? void 0 : _b.right) !== undefined ? css(["padding-right:", ";"], px2rem((_c = props.customStyle) === null || _c === void 0 ? void 0 : _c.padding.right)) : undefined;
}, function (props) {
  var _a, _b, _c;
  return ((_b = (_a = props.customStyle) === null || _a === void 0 ? void 0 : _a.padding) === null || _b === void 0 ? void 0 : _b.bottom) !== undefined ? css(["padding-bottom:", ";"], px2rem((_c = props.customStyle) === null || _c === void 0 ? void 0 : _c.padding.bottom)) : undefined;
});
var FlatButton = styled(BaseButton).attrs(function (props) {
  return {
    loaderColor: props.theme.colorV2.colorSet.white1000
  };
}).withConfig({
  displayName: "FlatButton",
  componentId: "sc-qi275p-0"
})(["", " ", ""], function (props) {
  var _a;
  var color = props.theme.getColorByAlias(props.color, (_a = props.theme.getButtonElementPalette("button").color) !== null && _a !== void 0 ? _a : props.theme.colorV2.primary.main);
  var textColor = props.scale ? props.scale === ThemeColorScaleTypes.BLACK ? props.theme.colorV2.colorSet.grey800 : props.theme.colorV2.colorSet.white800 : props.theme.getButtonElementPalette("button").fog800;
  return css(["border:1px solid ", ";background-color:", ";color:", ";", ""], color, color, textColor, props.isActive ? css(["border:1px solid ", ";background-color:", ";color:", ";"], rgba(color, 0.14), rgba(color, 0.14), color) : null);
}, function (props) {
  return props.size === "custom" ? commonStyle : undefined;
});
var GhostButton = styled(BaseButton).withConfig({
  displayName: "GhostButton",
  componentId: "sc-qi275p-1"
})(["", " ", ""], function (props) {
  var _a;
  var color = props.theme.getColorByAlias(props.color, (_a = props.theme.getButtonElementPalette("button").color) !== null && _a !== void 0 ? _a : props.theme.colorV2.primary.main);
  return css(["background-color:transparent;color:", ";border:", " solid ", ";", ""], color, px2rem(1), color, function () {
    if (props.isActive) {
      return "\n        color: ".concat(color, ";\n        background-color: ").concat(rgba(color, 0.14), ";\n        border: 1px solid transparent;\n      ");
    }
  });
}, function (props) {
  return props.size === "custom" ? commonStyle : undefined;
});
var TextButton = styled(BaseButton).withConfig({
  displayName: "TextButton",
  componentId: "sc-qi275p-2"
})(["", " background-color:transparent;", ""], function (props) {
  var _a;
  var color = props.theme.getColorByAlias(props.color, (_a = props.theme.getButtonElementPalette("button").color) !== null && _a !== void 0 ? _a : props.theme.colorV2.primary.main);
  return css(["color:", ";"], color);
}, function (props) {
  return props.size === "custom" ? commonStyle : undefined;
});
var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-qi275p-3"
})(["width:100%;display:flex;justify-content:", ";"], function (props) {
  return blockAlign2FlexAlign(props.align);
});

export { FlatButton, GhostButton, TextButton, Wrapper };
